{
  "title": "Payments",
  "tabs": {
    "actionNeeded": "Action needed",
    "complete": "Complete",
    "processed": "Processed",
    "drafts": "Drafts",
    "funded": "Funded",
    "inProgress": "In Progress",
    "pending": "Pending",
    "pendingAction": "Pending Action",
    "scheduled": "Scheduled",
    "rejected": "Rejected & Unsuccessful"
  },
  "paymentDrawer": {
    "paymentDetailsCard": {
      "title": "Payment Details",
      "status": "Payment Status",
      "id": "Payment ID",
      "reference": "Reference",
      "purpose": "Purpose of Payment",
      "fixedAmount": "Fixed Amount",
      "valueDate": "Value Date",
      "createdBy": "Created By",
      "createdAt": "Created At",
      "cutOffTime": "Cut-off Time"
    },
    "scheduledDetailsCard": {
      "title": "Schedule",
      "valueDate": "Value Date",
      "repeats": "Repeats",
      "endDate": "End Date",
      "never": "Never",
      "alert": {
        "firstPoint": "The live FX rate for payments which require foreign exchange will be automatically accepted on the date the payment is scheduled to be sent.",
        "secondPoint": "Payments scheduled to be sent on a weekend or national holiday will be sent the next banking day.",
        "thirdPoint": "In months with dates that do not occur every month, such as the 31st, the payments will be made on the last day of the month."
      }
    },
    "fromDetailsCard": {
      "title": "Fund from",
      "entity": "Entity",
      "fundingAccount": "Funding Account",
      "friendlyName": "Friendly name",
      "currency": "Currency",
      "swiftBic": "SWIFT/BIC",
      "iban": "IBAN",
      "accountNumber": "Account Number"
    },
    "beneficiaryDetailsCard": {
      "title": "Beneficiary details",
      "name": "Name",
      "vopResult": "Verification of Payee result",
      "vopResultTooltip": "For certain payments we check that the beneficiary name entered matches the details held by the bank.",
      "friendlyName": "Friendly name",
      "country": "Country",
      "type": "Type",
      "currency": "Currency",
      "address": "Address",
      "bankName": "Bank name",
      "swift": "SWIFT/BIC",
      "iban": "IBAN",
      "accountNumber": "Account Number",
      "sortCode": "Sort Code",
      "bankCode": "National bank code",
      "corrAccNumber": "Correspondent account number",
      "corrSwift": "Correspondent SWIFT",
      "furtherAccNumber": "Further to account number",
      "furtherSwift": "Further to SWIFT"
    },
    "approverDetailsCard": {
      "title": "Approvals",
      "needed": "Approvals needed",
      "approved": "Approval",
      "rejected": "Rejected by",
      "bankRejected": "Rejected by the bank"
    },
    "chargesDetailsCard": {
      "title": "Charges",
      "paymentAmount": "Payment amount",
      "beneficiaryDeduct": "Beneficiary Deduct",
      "beneficiaryReceives": "Beneficiary receives"
    },
    "transferDetailsCard": {
      "title": "Transfer details",
      "fixedSide": "Fixed side",
      "debitingAccount": "Debiting account",
      "rate": "Rate",
      "beneficiaryReceives": "Beneficiary receives",
      "entity": "Entity",
      "friendlyName": "Friendly name",
      "currency": "Currency",
      "swiftBic": "SWIFT/BIC",
      "iban": "IBAN",
      "accountNumber": "Account Number"
    },
    "beneficiaryCheckCard": {
      "title": "Beneficiaries check",
      "result": "Result",
      "name": "Name entered",
      "beneficiaryType": "Beneficiary type",
      "accountNumber": "Account Number"
    }
  },
  "beta": "Beta",
  "view": "View as: ",
  "download": "Download",
  "dataErrorToastTitle": "Something went wrong. Please try again. If the problem persists, please contact Client Services.",
  "dataErrorToastBody": "If the problem persists, please contact Client Services.",
  "paymentTypeTabs": {
    "individual": "Individual Payments",
    "batched": "Batched Payments"
  },
  "buttons": {
    "bulkImport": "Bulk Import",
    "createPayments": "Create Payments"
  },
  "table": {
    "searchIndividual": "Search payments",
    "searchPlaceholder": "Search payment batches",
    "headers": {
      "action": "Action",
      "amount": "Amount",
      "approved": "Approved",
      "batchName": "Batch name",
      "beneficiary": "Beneficiary",
      "created": "Created",
      "valueDate": "Value Date",
      "fundingEntity": "Funding entity",
      "idSource": "ID & Source",
      "nextPayment": "Next payment",
      "noOfPayments": "No. of payments",
      "noOfProcessedPayments": "Processed Payments",
      "reference": "Reference",
      "status": "Status",
      "fundFrom": "Fund from",
      "fixedAmount": "Fixed Amount",
      "batchIdSource": "Batch ID & Source",
      "rejected": "Rejected/Cancelled",
      "totalPayments": "Total Payments",
      "totalPendingPayments": "Pending Action",
      "totalApprovedPayments": "Approved",
      "totalRejectedPayments": "Rejected",
      "failed": "Failed"
    },
    "chips": {
      "autoDeposit": "Auto Deposit"
    },
    "tableFilters": {
      "fundFrom": {
        "searchPlaceholder": "Entity"
      }
    },
    "tooltip": {
      "autoDeposit": "This payment is an automatic transfer to fund a deposit.",
      "valueDate": "This is the scheduled processing date the payment should be sent.",
      "fundingEntities": "Funding entities",
      "hiddenPayments": "Total payments in batch {{totalPayments}}. You have access to view {{totalVisiblePayments}} {{visiblePaymentsLabel}}. You don't have access to {{hiddenCount}} {{hiddenPaymentsLabel}}.",
      "payment": "payment",
      "payment_one": "payment",
      "payment_other": "payments",
      "approvedVisibilityNote": "Approved count reflects only the payments you have access to",
      "rejectedVisibilityNote": "Rejected count reflects only the payments you have access to",
      "pendingVisibilityNote": "Pending count reflects only the payments you have access to",
      "noPermissionResumeTooltip": "Only the user who created this draft payment can resume it."
    },
    "dataError": "Access to view payment batches for the selected entities is restricted for the current user",
    "dropdown": {
      "delete": "Delete batch",
      "release": "Release batch",
      "resume": "Resume",
      "view": "View batch",
      "viewAction": "View batch / action batch",
      "viewDetails": "View details",
      "viewPaymentDetail": "View payment detail",
      "download": "Download",
      "deletePayment": "Delete payment",
      "deleteStandingOrder": "Delete Standing Order",
      "sendEmailReminderToApprovers": "Send email reminder to approvers",
      "bookFX": "Book FX",
      "approvePayment": "Approve payment",
      "rejectPayment": "Reject payment",
      "resumePayment": "Resume payment"
    },
    "rows": {
      "processing": "Processing..."
    },
    "components": {
      "na": "N/A",
      "paymentsType": {
        "batch": "This payment was created as part of a payment batch.",
        "standingOrder": "This is a recurring payment."
      },
      "approvalStatus": {
        "bookFx": "Book FX",
        "pendingApproval": "Pending approval"
      },
      "approverDetails": {
        "title": "Approvals",
        "noOfApprovers": "No. approvals needed"
      },
      "approverDetailsContent": {
        "noApprovers": "No approvers yet"
      },
      "paymentTypeAndIcon": {
        "file": "File",
        "api": "API",
        "manual": "Manual",
        "multiEntity": "Multi-entity",
        "multi-entity": "Multi-entity"
      },
      "fundingEntity": {
        "tooltipTitle": "Funding entities"
      },
      "moreInformation": {
        "content": "View the batch to find out more.",
        "title": "We require further information for one or more payments in this batch."
      },
      "nextPayment": {
        "everyDay": "Every day",
        "everyMinute": "Every Minute",
        "everyMonth": "Every month",
        "everyWeek": "Every week",
        "everyYear": "Every year",
        "fortnightly": "Fortnightly",
        "fourWeeks": "Every 4 weeks",
        "once": "Once",
        "quarterly": "Quarterly"
      },
      "paymentStatus": {
        "actionneeded": "Action needed",
        "active": "Active",
        "complete": "Complete",
        "error": "Error",
        "failed": "Failed",
        "inprogress": "In progress",
        "pendingapproval": "Pending approval",
        "processing": "Processing",
        "uploading": "Uploading",
        "bookfx": "Book FX",
        "draft": "Draft",
        "returned": "Returned",
        "pendingfx": "Pending FX",
        "rejected": "Bank rejected",
        "clientrejected": "Rejected",
        "cancelled": "Cancelled",
        "approvalInProgress": "Approving",
        "rejectionInProgress": "Rejecting",
        "verificationOfPayeeCheckInProgress": "Verifying beneficiary",
        "confirmationInProgress": "Submitting"
      },
      "standingOrderStatus": {
        "active": "Active",
        "failed": "Failed",
        "pendingapproval": "Pending approval",
        "deleted": "Deleted"
      }
    },
    "toolTips": {
      "rejectedBy": "Rejected by",
      "rejectedByBank": "Rejected by bank",
      "returnedByBank": "Returned by bank"
    },
    "filters": {
      "status": "Status",
      "scheduled": "Scheduled",
      "draft": "Draft",
      "pending-action": "Pending-action",
      "in-progress": "In-progress",
      "complete": "Complete",
      "rejected": "Rejected"
    },
    "verificationOfPayeeTooltip": {
      "viewInPaymentDetails": {
        "allDetailsMatch": "All beneficiary details match. View the full payment detail to learn more",
        "nameDoesntMatch": "Name does not match. View the full payment detail to learn more.",
        "checkNotRequired": "Beneficiary check not required",
        "checkBypassed": "Beneficiary check bypassed",
        "unableToCheck": "Unable to check details"
      },
      "reviewPayment": {
        "allDetailsMatch": "All beneficiary details match. Review the payment detail to learn more",
        "nameDoesntMatch": "Name does not match. Review the payment detail to learn more.",
        "checkNotRequired": "Beneficiary check not required",
        "checkBypassed": "Beneficiary check bypassed",
        "unableToCheck": "Unable to check details"
      }
    }
  },
  "notifications": {
    "pending": {
      "title": "Please note",
      "content": "Please note payments may take a short time to appear in pending payments. If you believe something has gone wrong, contact us."
    },
    "uploadTimeout": {
      "title": "Unable to upload payment file",
      "content": "Please try again. If the problem persists, please contact Client Services"
    }
  },
  "deletePaymentsModal": {
    "title": "Are you sure you want to delete these payments?",
    "title_one": "Are you sure you want to delete this payment?",
    "title_other": "Are you sure you want to delete these payments?",
    "bodyText": "This action cannot be undone.",
    "confirm": "Delete",
    "cancel": "Cancel",
    "error": "There was a problem deleting these payments",
    "error_one": "There was a problem deleting this payment",
    "error_other": "There was a problem deleting these payments",
    "success": "Payments were successfully deleted",
    "success_one": "Payment was successfully deleted",
    "success_other": "Payments were successfully deleted"
  },
  "deleteBatchModal": {
    "title": "Are you sure you want to delete this batch?",
    "bodyText": "This action cannot be undone.",
    "cancel": "Cancel",
    "yesDelete": "Yes, delete",
    "successToast": "Batch successfully deleted",
    "errorToast": "There was a problem deleting this batch"
  },
  "deleteStandingOrderModal": {
    "title_one": "Are you sure you want to delete this standing order?",
    "title_other": "Are you sure you want to delete these standing orders?",
    "bodyText": "This action cannot be undone.",
    "confirm": "Delete",
    "cancel": "Cancel",
    "error_one": "There was a problem deleting this standing order",
    "success_one": "Standing order was successfully deleted",
    "error_other": "There was a problem deleting these standing orders",
    "success_other": "Standing orders were successfully deleted"
  },
  "approveWithVopWarning": {
    "title": "Are you sure you want to continue?",
    "cancel": "Cancel",
    "approveAnyway": "Approve anyway",
    "batch": {
      "bodyText": "Before approving, please make sure you’ve checked the beneficiary details for all payments. To review the full beneficiary information, click into the payment detail.",
      "alertTitle": "Please note",
      "alert": "If the beneficiary details entered are incorrect the payment could go to the wrong account. <1> </1> <2>You could <1> lose your money </1> if you pay the wrong account.</2>"
    },
    "payments": {
      "bodyText": "For one or more payments you are approving the beneficiary details don’t match the account of the beneficiary. View the payment detail learn more.",
      "alertTitle": "Please note",
      "alert": "If you choose to continue you are accepting that the beneficiary details may be incorrect. You should check the details before continuing. <1> </1> <2>You could <1> lose your money </1> if you pay the wrong account.</2>"
    }
  },
  "batchSummary": {
    "noRejectPermissions": "You do not have permission to reject any payments in this batch.",
    "noApprovePermissions": "You do not have permission to approve any payments in this batch.",
    "noBookFxPermissions": "You do not have permission to book FX for any payments in this batch.",
    "noResumePermissions": "You do not have permission to resume the submission of this batch.",
    "bookFxTooltip": "Book FX for payments in the batch that are pending FX and within your approval permissions.",
    "approveBatchTooltip": "Approve all payments in the batch that are pending approval and within your approval permissions.",
    "rejectBatchTooltip": "Reject payments in the batch that are pending approval or pending FX and within your approval permissions.",
    "resumeBatchTooltip": "Resume the submission of this batch.",
    "resumeNotOwnDraftBatchTooltip": "Only the user who created this draft batch can resume it.",
    "error": "We're sorry, but we can't access this payment at the moment. If you believe this is a mistake, please contact our support team for assistance.",
    "view": "Click to view batch",
    "batchHeaderActions": {
      "disabled": {
        "paymentsSelected": "Deselect individual payments to enable"
      },
      "loading": {
        "refetchingBatch": "Refreshing batch details, please wait.",
        "batchActionInProgress": "Batch is being processed. Refresh the page to view the latest status."
      }
    },
    "batchActionStatus": {
      "verificationOfPayeeCheckInProgress": {
        "alert": {
          "title": "Some beneficiaries in this batch are still being verified",
          "content": "We’re verifying the beneficiaries for some payments in this batch. Refresh the page to see the latest status."
        }
      },
      "approvalInProgress": {
        "alert": {
          "title": "We’re processing your approvals",
          "content": "Some payments in this batch are still being approved. The payment statuses will update automatically once they’re complete."
        }
      },
      "rejectionInProgress": {
        "alert": {
          "title": "We’re processing your rejections",
          "content": "Some payments in this batch are still being rejected. The payment statuses will update automatically once they’re complete."
        }
      },
      "confirmationInProgress": {
        "alert": {
          "title": "We’re processing your submissions",
          "content": "Some payments in this batch are still being submitted. The payment statuses will update automatically once they’re complete."
        }
      }
    },
    "dropdown": {
      "delete": "Delete batch",
      "download": "Download batch summary",
      "ongoingDownload": "Another download is currently in progress. Please wait and try again once this is done."
    },
    "actionAlert": {
      "title": "Payments requiring action",
      "content": "Some of the payments in your batch require action. Please contact Client Services"
    },
    "approverDetails": {
      "approval": "Approval",
      "recentApprover": "Most recent approval",
      "noOfApproversNeeded": "No. of approvals needed"
    },
    "scheduledAlert": {
      "title": "This batch includes a scheduled payment",
      "content": "The FX rate for these payments will be automatically accepted when the payment is scheduled to be sent."
    },
    "buttons": {
      "approve": "Approve payments",
      "approveBatch": "Approve batch",
      "rejectBatch": "Reject batch",
      "checkAndApprove": "Check and Approve",
      "approveAnyway": "Approve anyway",
      "next": "Next",
      "cancel": "Cancel",
      "reject": "Reject payments",
      "bookFx": "Book FX",
      "paymentSummary": "Batch Summary",
      "remindApprovers": "Remind Approvers",
      "sendPayment": "Send Payment",
      "submitForApproval": "Submit payments for approval",
      "checkAndSubmit": "Check and submit Payments for approval",
      "submitAnyway": "Submit payments for approval anyway",
      "submitPayments": "Submit payments",
      "resumeBatch": "Resume Batch"
    },
    "valueCards": {
      "noOfPayments": "No. of payments",
      "createdBy": "Created by",
      "dateCreated": "Date created",
      "nextPayment": "Next payment",
      "taken": "Taken",
      "amount": "Amount",
      "beneficiary": "Beneficiary"
    },
    "amountsTable": {
      "currency": "Currency",
      "amount": "Amount",
      "fixedAmount": "Fixed Amount",
      "debitAmount": "Debit Amount",
      "creditAmount": "Credit Amount",
      "frequency": "Frequency",
      "download": "Download",
      "indicativeRate": "Indicative Rate"
    },
    "cutOff": {
      "time": "Cut-off time",
      "earliest": "Earliest process date",
      "eligible": "Eligible for processing to start today",
      "ineligible": "Today's cut-off time has passed"
    },
    "indicativeRate": {
      "curency": "Currency",
      "errors": {
        "badRequest": "Unable to process rate request. Please check your payment details.",
        "noAccess": "You do not have permission to view rates for these accounts.",
        "notFound": "Indicative Quote is unavailable for the selected currency pairs.",
        "generic": "Unable to fetch exchange rates. Please try again."
      }
    },
    "tableCards": {
      "amounts": "Amounts & Cut-off times",
      "amountsDescription": "Amount to be debited from the funding account",
      "fixedAlert": "Only fixed amounts are displayed below",
      "fixedAlertDescription": "Only fixed amounts are shown. Final send amounts may vary. Book FX to view the live FX rate and book payments.",
      "approvals": "Approvals",
      "approvalsDescription": "Approvals needed and given before payments sent",
      "approvalsDescriptionSubTitle": "Payments requiring approval before they can be sent.",
      "finalApprovals": "Only the final approval is displayed for in progress and completed batches. Full approval details for completed payments can be viewed in Transactions.",
      "cutOffTimes": "Cut-off times",
      "cutOffTimesDescription": "Deadlines for cross currency payments to be sent",
      "totalAmount": "Total amount",
      "hasHiddenPaymentsTitle": "Viewing {{visible}} of {{total}} payments"
    },
    "toolTips": {
      "indicativeInfo": "This is the indicative amount",
      "indicativeRateTitle": "Indicative rate",
      "indicativeRateDescription": "The first rate shown is market convention and the second rate shown is the counter convention.",
      "liveRateTitle": "Live rate"
    },
    "payment": "Payment",
    "payments": "Payments",
    "drawer": {
      "delete": "Delete",
      "dataLoading": "Retrieving your beneficiary data",
      "debitingAccountDetailsCardTitle": "Debiting Account Details",
      "fundingAccountDetailsCardTitle": "Funding Account Details",
      "download": "Download",
      "detailsCard": {
        "beneficiaryDetailsCardTitle": "Beneficiary Details",
        "name": "Beneficiary Name",
        "pendingTransactions": "Pending Transactions",
        "clearedBalance": "Cleared Balance",
        "availableBalance": "Available Balance",
        "currency": "Currency",
        "swift": "SWIFT/BIC",
        "iban": "IBAN",
        "accountNumber": "Account Number",
        "fundingDetailsCardTitle": "Paid From",
        "fundingAccount": "Funding Account",
        "debitingAccount": "Debiting Account",
        "paymentDetailsCardTitle": "Payment Details",
        "paymentId": "Payment ID",
        "startDate": "Start Date",
        "frequency": "Frequency",
        "nextDate": "Next Date",
        "endDate": "End Date",
        "paymentReference": "Payment Reference",
        "purposeOfPayment": "Purpose of Payment",
        "uploadedBy": "Uploaded By",
        "uploadedDate": "Uploaded Date"
      }
    },
    "download": {
      "fxDownload": "FX Trade download in progress",
      "singleDownload": "Payment Summary Download in progress",
      "batchDownload": "Batch Summary download in progress",
      "successMessage": "Successfully downloaded",
      "errorMessage": "Error processing download",
      "successfulDownload": {
        "title": "Batch Summary Downloaded",
        "pdf": "PDF with batch payment details has been saved.",
        "zip": "ZIP file with batch payment details has been saved. ",
        "fallback": "Your file has been successfully saved"
      }
    },
    "tabs": {
      "payments": "Payments",
      "details": "Details",
      "overview": "Overview"
    },
    "table": {
      "searchPlaceholder": "Search beneficiary name or payment ref",
      "dataError": "Access to view payments for the selected batch is restricted for the current user",
      "headers": {
        "fixedAmount": "Fixed amount",
        "paymentDate": "Value date",
        "paymentDateInfo": "Date your payment should be sent.",
        "paymentStatus": "Payment status",
        "action": "Action",
        "frequency": "Frequency"
      },
      "dropdown": {
        "view": "View",
        "download": "Download"
      },
      "components": {
        "status": {
          "active": "Active",
          "approved": "Approved",
          "cancelled": "Cancelled",
          "deleted": "Deleted",
          "draft": "Draft",
          "failed": "Failed",
          "invalid": "Invalid",
          "pending": "Pending",
          "pendingFx": "Pending FX",
          "pendingApproval": "Pending approval",
          "actionRequired": "Action Required",
          "inProgress": "In Progress",
          "rejected": "Rejected",
          "released": "Complete",
          "returned": "Returned",
          "uploaded": "Uploaded",
          "validated": "Validated",
          "outstanding": "Outstanding"
        },
        "missingDocuments": {
          "trigger": "Documents needed",
          "docsRequiredTitle": "To process your payment, please provide the following document(s) to client services:",
          "content": "We may have already contacted you. Please reply to our email or send the documents to clientservices-abs@alphagroup.com"
        }
      }
    },
    "title": "Batch Summary",
    "cannotFindBatchId": "Unable to proceed. Cannot find Batch Id.",
    "findBatch": {
      "error": {
        "title": "Unable to find payment batch",
        "body": "It may no longer be available or accessible to you."
      }
    }
  },
  "createPayments": {
    "formTitle": "Create Payments",
    "reviewPayments": "Review",
    "fromDetailsTitle": "From",
    "paymentDetailsTitle": "Payment Details",
    "summaryTitle": "Summary",
    "fxRateBookingTitle": "FX Rate Booking",
    "beneficiariesVerification": {
      "title": "Beneficiaries Check",
      "description": "For eligible payments, we automatically check the beneficiary name and account details with the beneficiary bank.",
      "autoSkippedTooltip": "All eligible beneficiaries were checked, and no action is required, so this step was skipped.",
      "detailsCards": {
        "checkedBeneficiaries": "Checked Beneficiaries",
        "totalBeneficiaries": "Total Beneficiaries",
        "issues": "Issues",
        "checkEligible": "Check eligible",
        "totalCheckedPayments": "Checked payments",
        "checkEligibleTooltip": "For EUR-to-EUR payments from European entities, we check the beneficiary name matches the details held by their bank."
      },
      "unableToCheckDetails": "Unable to check details",
      "checkedPayments": "Checked payments",
      "errorAlert": "Until we are able to check the details you entered, you won't be able to send money to the beneficiaries at this time. <1>Please try again in a few minutes. If the problem continues, please contact Client Services.</1>",
      "pleaseNote": "Please note",
      "warningAlert": "If you choose to continue you are accepting the details may be incorrect. You should check the details before continuing. Select ‘Return to payments’ to remove the payment or change the beneficiary.<1> </1> <2>You could <1> lose your money </1> if you pay the wrong account.</2>",
      "beneWarningAlert": "If you choose to continue you are accepting that the beneficiary details may be incorrect. You should check the details before continuing. <1> </1> <2>You could <1> lose your money </1> if you pay the wrong account.</2>",
      "errorDescription": "We can't check the details you entered because the beneficiary checking service is currently unavailable. Please try again in a few minutes. If the problem persists, please contact Client Services.",
      "successDescription": "Please review the beneficiary details below carefully before continuing, ensuring the information is correct and the payment request is genuine.",
      "details": {
        "labels": {
          "nameEntered": "Name entered",
          "nameFound": "Name found",
          "beneficiaryType": "Beneficiary type",
          "beneficiaryName": "Beneficiary Name",
          "accountNumber": "Account Number",
          "sortCode": "Sort Code",
          "swift": "SWIFT",
          "iban": "IBAN",
          "amount": "Amount",
          "reference": "Reference",
          "verificationStatus": "Verification Status",
          "checkedAt": "Checked At"
        }
      },
      "table": {
        "columns": {
          "fundFrom": "Fund from",
          "fixedAmountAndReference": "Fixed amount & reference",
          "beneficiary": "Beneficiary",
          "verificationCheck": "Verification check"
        },
        "actions": {
          "viewDetail": "View detail"
        }
      },
      "errors": {
        "invalid": "We couldn’t process your request. Please check that the payment IDs or batch ID are valid.",
        "blockingTitle": "Some beneficiaries have issues",
        "blockingBody": "These need to be resolved before you can continue. Please contact Client Services if you need help.",
        "generalError": "Something went wrong",
        "generalErrorBody": "We couldn’t complete the beneficiary verification. Please try again. If the problem persists, please contact Client Services."
      },
      "back": "Return to payments",
      "next": {
        "continueAnyway": "Continue to review anyway",
        "continue": "Continue to review",
        "cannotProceedTooltip": "Unfortunately you cannot continue with this process. Please reach out to client services."
      },
      "retryCheck": "Try again"
    },
    "fromDetails": {
      "formTitle": "Where is the payment being sent from?",
      "formSubTitle": " Please select which entity and currency account you want to send this payment from.",
      "entityLabel": "Entity",
      "entityPlaceholder": "Select Entity",
      "fundingAccountLabel": "Funding Account",
      "fundingAccountPlaceholder": "Select Funding Account",
      "frozenEntityError": "Sorry, this account is frozen and can't be selected.",
      "europeAlertTitle": "The bank cut-off time for GBP payments debiting a European entity account is {{date}}",
      "europeAlertContent": "To ensure your payment is processed with the best available value date, we recommend submitting it well before the cut-off time."
    },
    "paymentDetails": {
      "details": "Detail",
      "beneficiaryLabel": "Beneficiary",
      "noBeneficiaryFound": "No beneficiaries found",
      "changeDetails": "Change details",
      "balance": "Balance",
      "account": "Account",
      "addNewPayment": "Add another payment",
      "addNewPaymentTooltip": "You've added the maximum number of payments ({{count}}) to this batch. To continue, please submit this one and create a new batch.",
      "singleCurrency": "Single Currency",
      "crossCurrency": "Cross Currency",
      "multiCurrency": "Multi-Currency",
      "purposeOfPaymentPlaceholder": "Enter purpose of payment",
      "purposeTooltipText": "Some beneficiary countries require a specific reason for the payment to be provided. This is known as the 'Purpose of Payment.' It ensures transparency and compliance with local regulations. If required, please select or enter the reason for the transaction.",
      "ready": "Ready To Submit",
      "incomplete": " Incomplete",
      "action": "Action Needed",
      "incompletePaymentAlert": "Payment needs to be complete if you want to process as part of batch",
      "purposeOfPaymentOptional": "Purpose of payment",
      "purposeOfPaymentLabel": "Purpose of payment",
      "moreOptions": "More Options",
      "dataLabel": "Value Date",
      "dataSubLabel": "Date your payment should be sent.",
      "referenceLabel": "Reference",
      "referencePlaceholder": "Enter reference",
      "amountLabel": "Amount",
      "amountPlaceholder": "Enter Amount",
      "fixedSideLabel": "Fixed Side",
      "debitAccountLabel": "Debiting account",
      "debitingAccountTooltip": "An account that holds the currency in which you want to make the payment. Funds will be converted to this currency and transferred from the funding account to the debiting account before being sent to the beneficiary.",
      "debitingAccountSubLabel": "Select where the funds will be debited from.",
      "debitingAccountPlaceholder": "Select a debiting account",
      "linkText": "Want to pay someone new?",
      "debitingAccountAlert": {
        "title": "Can’t see the debiting account in the list?",
        "body": "Call us to activate your currency account"
      },
      "beneficiarySubLabel": "Who do you want to pay?",
      "beneficiaryPlaceholder": "Search for or select a beneficiary",
      "defaultModal": {
        "title": "Are you sure?",
        "bodyText": "You have unsaved changes. If you continue, these changes will be lost. Are you sure you want to continue?"
      },
      "incompletePaymentsModal": {
        "title": "Incomplete payments will not be processed",
        "bodyText": "Continuing will only take stored or complete payments to be submitted. If you would like to process the payment please press ‘cancel’ and complete payment before continuing"
      },
      "changeDetailsModal": {
        "title": "Are you sure you want to change details?",
        "bodyText": "Payment batches can only be sent from the same entity and funding account. If you change the funding entity and account, any payment details already entered will be cleared.",
        "bodyTextV2": "Payments must be sent from the same entity and funding account. If you change the funding entity and account, any payment details already entered will be cleared."
      },
      "multiEntityChangeDetailsModal": {
        "title": "Change Funding Entity & Account for Payment {{paymentIndex}}",
        "bodyText": "Any payment details you have already entered for this payment will be cleared",
        "continueButton": "Clear detail"
      },
      "changeCurrencyModal": {
        "singleCurrencyTitle": "This batch contains single currency payments",
        "crossCurrencyTitle": "This batch contains cross-currency payments",
        "singleCurrencyBody": "The beneficiary you are trying to select uses a different currency as the funding account. Single currency payment batches cannot include cross-currency payments. Please clear the batch to add a cross-currency payment.",
        "crossCurrencyBody": "The beneficiary you are trying to select uses the same currency as the funding account. Cross-currency payment batches cannot include single currency payments. Please clear the batch to add a single currency payment.",
        "continueText": "Clear Batch"
      },
      "deletePaymentModal": {
        "title": "Are you sure you want to remove payment {{paymentIndex}}?",
        "bodyText": "Any information inputted will not be stored."
      },
      "continue": "Continue to Summary",
      "checkDetailsAndContinue": "Check details and continue",
      "paymentType": {
        "subLabel": "This is how the payment will be sent.",
        "label": "Payment type",
        "placeholder": "Select a payment type",
        "toolTipContent": "Depending on your payment, different types of bank transfers may be available. Each option has varying costs, speeds, and requirements. You can choose the payment type that best suits your needs.",
        "alert": {
          "content": "SEPA payments have a cut-off time of {{time}}. If you have any questions, please contact Client Services at ",
          "title": "Please note"
        }
      },
      "specialCharactersMessage": "Please remove any special characters",
      "specialCharactersReferenceMessage": "Please remove any special characters except /-?:().,'+",
      "referenceSpecialCharactersErrorMessage": "Please remove any invalid characters. Only letters, numbers, spaces, and the following symbols are allowed: / - ? : ( ) . , ' + ",
      "maxLengthMessage": "Field must be 250 characters or less",
      "cannotCreateBatchStandingOrder": "You can’t add more payments because standing orders can’t be part of a batch.",
      "multiEntitySignposting": {
        "alertContent": "Add another payment, even from a different entity, and submit everything in one go.",
        "alertTitle": "Making payments from more than one entity?"
      }
    },
    "validations": {
      "notAuthorizeError": "Access to view currency Account for the selected entity is restricted for the current user",
      "notFoundError": "No currency accounts found for the selected entity.",
      "amountValidation": "Amount must be greater than 0.00"
    },
    "errors": {
      "unauthenticatedApiCall": "An unexpected error occurred. If this issue continues, please contact our Client Services team for assistance.",
      "userCannotResumeNotOwnPayment": {
        "title": "Unable to submit payment(s)",
        "body": "You can only submit payments that you have created."
      },
      "submitPaymentError": "There was an error submitting your payment",
      "supportingDocsError": "Supporting documents cannot have the same name",
      "tooManyRequests": "Too many requests, please wait 5 minutes or try an alternative method",
      "timeoutTitle": "Authy Notification Not Approved in Time",
      "timeoutBody": "If you missed the notification, please ensure your device is connected to the internet and try again, or select another authentication method.",
      "genericVerificationIssue": "Payment verification failed. If the issue persists, please contact Client Services for assistance.",
      "actionNeeded": "It looks like there's an issue with your payment. Please hover over the 'Action Needed' notification for more details.",
      "paymentApprovalInBackground": {
        "title": "We’re processing your approval.",
        "body": "Large batches may take a little longer to complete. The payment statuses will update automatically once they’re complete."
      },
      "paymentsApprovalFailed": "{{totalPayments}} payment(s) could not be approved.",
      "paymentsApprovalFailedBody": "You do not have permission to approve these payments.",
      "approverOwnFailed": "An error has occurred when approving payments.",
      "paymentSubmittedButApproverOwnFailed": "The payment(s) have been successfully submitted, but have not been approved. This can be done separately.",
      "approvalExpired": {
        "title": "Approval expired",
        "body": "Your approval session has expired. Please start the approval again."
      }
    },
    "info": {
      "codeSend": "A code has been sent to your device.",
      "pushSend": "A push notification has been sent to your device."
    },
    "success": {
      "paymentApproved": "Payment batch approved successfully.",
      "paymentSubmitted": "Payment batch submitted successfully.",
      "paymentsSuccessfullyApproved": "{{totalProcessedPayments}} of {{totalPayments}} payment(s) successfully approved",
      "fxBookingPending_one": "Your payment is waiting for FX rate booking.",
      "fxBookingPending_other": "Some payments in the batch are waiting for FX rate booking.",
      "paymentsSubmittedSuccessfully": "Payment(s) submitted successfully"
    },
    "asyncSuccess": {
      "paymentsSubmitted": "We’re processing your submission"
    },
    "partialSuccess": {
      "paymentsPartiallyProcessed": "{{totalProcessedPayments}} of {{totalPayments}} payment(s) successfully approved.",
      "paymentsPartiallyProcessedBody": "You are unable to approve {{totalFailedPayments}} payment(s)."
    },
    "standingOrder": {
      "setNumber": "Set number of payments",
      "onDate": "Specific date",
      "untilFurtherNotice": "Until further notice",
      "placeHolder": "Please select",
      "label": "Repeat payment",
      "SubLabel": "Set up standing order",
      "repeatFrequencyLabel": "Repeat",
      "repeatFrequencySubLabel": "How often should this payment repeat?",
      "repeatUntilLabel": "Continue until",
      "noOfPaymentsLabel": "Number of payments",
      "noOfOfPaymentsPlaceholder": "Enter number of payments",
      "noOfPaymentsValidation": "Number of payments must be 1 or higher",
      "alert": {
        "label": "Things to know",
        "line1": "The live FX rate for payments that require foreign exchange will be automatically accepted on the date the payment is scheduled to be sent.",
        "line2": "Payments scheduled to be sent on a weekend or national holiday will be sent the next banking day.",
        "line3": "In months with dates that don't occur every month, such as the 31st, the payment will be made on the last day of the month."
      }
    },
    "supportingFile": {
      "fieldLabel": "Supporting documents",
      "uploadError": "Payment submission still in progress but some documents have failed to upload. We may contact you if we need more information.",
      "allowedExtensions": "Supported file types: .pdf .jpg .jpeg .png .doc .docx .xls .xlsx .ppt .pptx",
      "modalText": "Depending on your payment, we might need further supporting information and may ask to see some documents.",
      "modalTitle": "Add supporting document",
      "infoTitle": "Why should I provide documents ?",
      "infoText": "It's a good idea to provide your documents when you create a payment. This will help to speed up the process if we do need to see them. To learn more about these requested documents, contact client services at:",
      "addDocument": "Add document",
      "tooltipText": "Depending on your payment, we might need further supporting information and may ask to see some documents. It's a good idea to provide your documents when you create a payment. This will help to speed up the process if we do need to see them. To learn more about these requested documents, contact client services at clientservices-abs@alphagroup.com"
    }
  },
  "uploadPayments": {
    "reportBeingGenerated": "Error report is being generated. This might take a while",
    "totalPayments": "Total Payments",
    "invalidPayments": "Invalid Payments",
    "continueInvalidPaymentsText": "Continue and remove invalid payments",
    "reuploadText": "Re-upload file",
    "multipleFields": "Multiple Fields",
    "row": "Row",
    "unknownFailureAlert": "We couldn't process your file. Please ensure it matches the required template. If the issue persists, contact Client Services for support.",
    "uploadHeader": "Upload batch payment file",
    "loadingHeader": "Uploading file..",
    "fileUploadHeader": "File upload",
    "loadingSubTitle": "Your file hasn't been imported yet. If any errors are identified please fix them and re-upload the payment file to continue.",
    "loadingStates": {
      "uploadProgressText": "Uploading Your File...",
      "validateProgressText": "Validating your file...",
      "vopCheckingText": "Verifying beneficiaries...",
      "pendingProcessingText": "Preparing batch for processing...",
      "downloadingText": "Loading batch details...",
      "validatingText": "Validating payments...",
      "vopCheckingAlert": {
        "content": "We’re verifying the beneficiaries in your file. This may take a few minutes.",
        "title": "Please note"
      }
    },
    "uploadProgressText": "Uploading Your File...",
    "validateProgressText": "Validating your file...",
    "fundingEntityPlaceholder": "Select a entity",
    "supportedFilesText": "Supported file types: {{formats}}",
    "maxPaymentText": "Maximum payments per file: 12500",
    "maxMultiEntityText": "Maximum entities per file: 100",
    "maxMultiEntityError": "This file includes payments funded from more than 100 entities. Please reduce the number of entities and try uploading the file again.",
    "maxPaymentsError": "This file includes more than 12500 payments. Please reduce the number of payments and try uploading the file again.",
    "maxFileSizeText": "Maximum file size: 20MB",
    "legacyTemplate": "Legacy Download",
    "standardTemplate": "Download",
    "dragOrDrop": "Drag and Drop or",
    "choose": "choose",
    "fileToUpload": "files to upload",
    "downloadErrorReport": "Download error report",
    "field": "Field",
    "description": "Description",
    "previous": "Previous",
    "next": "Next",
    "errors": "Errors",
    "errorCreatingBatch": {
      "title": "Error creating batch",
      "body": "There was an error creating the batch. Please try again. If the problem persists, please contact Client Services."
    },
    "purposeOfPaymentsContent": "You need to include a Purpose of Payment code when submitting UK domestic payments.",
    "purposeOfPaymentsLink": "View the list of codes",
    "continueWithValid": "Continue and remove {{count}} invalid payments",
    "continueWithValid_one": "Continue and remove {{count}} invalid payment",
    "continueWithValid_other": "Continue and remove {{count}} invalid payments",
    "fileTypeSection": {
      "title": "File type",
      "Single-entity": {
        "title": "Legacy",
        "description": "Previously called single-entity"
      },
      "Multi-entity": {
        "title": "Standard",
        "description": "Use this format for all payments"
      },
      "legacyRetirementAlert": {
        "title": "Legacy file format retirement planned",
        "description": "Please use the standard payment file type to avoid future disruption."
      },
      "postRetirementAlert": {
        "title": "Full structured beneficiary addresses are now required",
        "description": "Your file must include the beneficiary’s full address, with each address element provided in the relevant field. Payments with incomplete or unstructured addresses will be rejected."
      },
      "standardBanner": {
        "title": "Start including beneficiary addresses now",
        "beforeDate": "To meet upcoming payment regulations, full beneficiary addresses will be required",
        "afterDate": "in the future."
      }
    },
    "retiringLegacyFileFormat": {
      "title": "Why are we retiring our legacy file format?",
      "paragraph1": "Upcoming payment regulations require beneficiary addresses to be provided in a structured format. This means each part of the address (address line 1, town/city, country, and so on) must be submitted as a separate field rather than as free text.",
      "paragraph2": "The legacy file format was designed before this requirement existed and does not support structured address data. In the future, payments submitted without a structured beneficiary address may be rejected by the payment network.",
      "paragraph3": "The standard file format supports structured addresses and is the right format to use for all payments going forward."
    },
    "diffBetweenLegacyStandard": {
      "title": "What is the difference between the Legacy and Standard file types?",
      "paragraph1": "The standard file format is an updated version of the legacy format that supports structured beneficiary addresses and our latest payment features. Most of the fields are the same, the key difference is that the standard format includes separate columns for each part of the beneficiary's address (such as address line 1, town/city and country), rather than a single address field.",
      "paragraph2": "The standard format also includes a Funding Entity column, which allows you to submit payments across multiple entities in a single file. If all of your payments are funded from the same entity, simply enter the same funding entity name for every row.",
      "paragraph3": "If you currently use the legacy format, you can download the standard template by selecting the standard file type and opening \"Need help getting started?\" below."
    },
    "helpGettingStarted": {
      "title": "Need help getting started?",
      "templateDownload": {
        "singleEntity": {
          "header": "Don’t have the Legacy template?",
          "subtitle": "Download the Legacy batch payments template here."
        },
        "multiEntity": {
          "header": "Payment File Template",
          "subtitle": "Use this template to provide full structured address details for each beneficiary."
        }
      },
      "instructions": "Download the file template, add your payment and beneficiary details, then upload it. One file can fund payments from multiple entities and currencies.",
      "destinationDetails": {
        "intro": "Some details depend on where the payment goes:",
        "ukDomesticPurposeCode": "UK domestic payments need a purpose of payment code."
      }
    },
    "accessIssuesTable": {
      "header": "Access issues",
      "tooltipTitle": "You may see this if:",
      "tooltip": "<0><0>You don’t have permission to create payments for an entity</0><1>You’re not a user on the entity</1><2>There’s a typo in the entity name</2></0><1>Check the entity name in your file and compare it with the entities available to you in the entities section of the portal.</1>",
      "alertNotice": "You don't have access to create payments for {{numberOfEntities}} entity names entered in this file ({{numberOfPayments}} payments).",
      "columnHeading": {
        "entityNames": "Entity names entered in file",
        "paymentAmounts": "Payments"
      }
    },
    "validateFileError": {
      "apiError": {
        "title": "File validation failed",
        "body": "Your file could not be validated. Please check entity names and permissions. If the issue continues, please contact Client Services."
      }
    },
    "structuredAddressRequired": {
      "alert": {
        "message": "To make payments from this entity, please select the Multi-entity file type and upload the Multi-entity template."
      }
    }
  },
  "summaryForm": {
    "title": "FX Rate Booking",
    "indicativeFailed": "Indicative rate failed.",
    "recipientsGetLabel": "Recipients get",
    "recipientLabel": "Recipient gets",
    "liveRate": "Live rate",
    "indicativeRate": "Indicative rate",
    "total": "Your total",
    "fundLabel": "Fund amount",
    "showPayments": "Show payments",
    "hidePayments": "Hide payments",
    "requestLiveRate": "Request live rates",
    "bookPayments": "Book payments",
    "youSend": "You send",
    "trade": {
      "successBody": "Your payment is now in progress",
      "successTitle": "Exchange rate successfully confirmed",
      "draftPaymentAlert": "The final send amounts may vary based on the exchange rate viewed and confirm after submitting the payments.",
      "indicativeAlert": "Final send amounts may vary. Click ‘Request live rates’ to view the counter convention FX rate and book payments.",
      "indicativeTitle": "Amounts indicative",
      "note": "Please note",
      "liveRateAlert": "By clicking ‘Book’ you will enter into a legal contract with Alpha to buy or sell the currencies you have selected.",
      "timeExpire": "The live rate will expire in",
      "scheduledTitle": "Amounts and FX rates are indicative",
      "bookingTradeProgress": "Booking your trade... Please wait.",
      "scheduledContent": "Final amounts may differ. The FX rate will be accepted automatically when the payment is scheduled, and it may differ from the rate shown here."
    },
    "missingCurrencyPairSummariesBody": "You may not have permission to book FX for these payments",
    "missingCurrencyPairSummariesTitle": "There are no FX payments available to book",
    "pendingApprovalBody": "Your payment(s) are now pending approval",
    "pendingApprovalTitle": "Payment(s) successfully submitted",
    "paymentApproved": "Payment(s) successfully approved",
    "paymentApprovalTitle": "Payment might take a short while to appear",
    "returnToPayments": "Return to payments",
    "returnToBeneficiariesVerification": "Return to Beneficiaries verification",
    "batch": "Batch",
    "payment": "Payment",
    "status": "Status",
    "totalNo": "Total number of payments",
    "approvalsNeeded": "Approvals needed",
    "approvals": "Approvals",
    "approved": "Approved",
    "inputter": "Inputter",
    "requireFxBody": "Payment approved, but rate booking is still required.",
    "releasedBody": "Payment has been released.",
    "fraudAlert": {
      "title": "Fraud Alert",
      "nextButton": "Submit Beneficiary",
      "confirmationCheckbox": "I confirm the beneficiary details entered are correct."
    },
    "scheduledPayment": "scheduled payment",
    "indicativeRateAlert": "Unable to fetch indicative rate",
    "indicativeRateAlertBody": "You can still submit the payments. The exchange rate can be viewed and confirmed after submitting the payments.",
    "approvedIndicativeRateAlertBody": "You can still request live rate for the payments and book the payments.",
    "confirmationOfPayee": {
      "title": "Beneficiaries check",
      "noBeneInfo": "No response available for this beneficiary."
    }
  },
  "deleteModal": {
    "standingOrderTitle": "Cancel standing order?",
    "standingOrderDesc": "The standing order will be deleted and no future payments will be sent.",
    "pendingTitle": "Are you sure you want to delete this batch?",
    "pendingDesc": "This is irreversible and the batch will be permanently deleted.",
    "yesCancel": "Yes, cancel",
    "no": "No",
    "delete": "Delete",
    "cancel": "Cancel",
    "deleteSuccess": "Payment deleted successfully",
    "deleteError": "Error occurred during payment delete"
  },
  "rejectModal": {
    "successMessage": "Successfully rejected payment",
    "errorMessage": "Failed to reject the payment/s due to an error.",
    "yesReject": "Yes, reject batch",
    "description": "This action cannot be undone. The payments in the batch will not be processed.",
    "title": "Reject batch?"
  },
  "rejectPaymentsModal": {
    "title": "Are you sure you want to reject this payment?",
    "title_one": "Are you sure you want to reject this payment?",
    "title_other": "Are you sure you want to reject these payments?",
    "titleBatch": "Are you sure you want to reject this batch?",
    "subTitle": "This action cannot be undone.",
    "cancel": "Cancel",
    "reject": "Reject Payment",
    "reject_one": "Reject Payment",
    "reject_other": "Reject Payments",
    "genericErrorMessage": {
      "title": "An error occurred whilst rejecting payments",
      "description": "If the problem persisits, please contact Client Services."
    },
    "rejectByPaymentIds": {
      "successMessage": "{{totalPaymentsRequested}} of {{totalPaymentsRequested}} payments successfully rejected.",
      "failureMessage": {
        "title": "Unable to reject payments",
        "description": "Refresh the page to view the latest status."
      },
      "partialSuccess": {
        "title": "{{processed}} of {{totalPaymentsRequested}} payments successfully rejected",
        "description": "You are unable to reject {{failedToReject}} payment(s)."
      }
    },
    "rejectByBatchId": {
      "successMessage": "{{totalPaymentsRequested}} of {{totalPaymentsRequested}} payments successfully rejected.",
      "partialSuccess": {
        "title": "{{processed}} of {{totalPaymentsRequested}} payments successfully rejected",
        "description": "You don’t have permission to reject {{failedToReject}} payments."
      },
      "asyncMessage": {
        "title": "We’re processing your rejections",
        "description": "Some payments in this batch are still being rejected. The payment statuses will update automatically once they’re complete."
      }
    }
  },
  "remindModal": {
    "actionDropdownLabel": "Send email reminders to approvers",
    "title": "Send approval reminder",
    "subTitle": "Ensure the quick approval of payments by sending an email reminder to selected approvers.",
    "successMessage": "Successfully sent email reminders",
    "partialSuccess": "Your email has been sent successfully to {{notifiedUsers}} user(s), but we couldn't deliver it to {{invalidUsers}} user(s).",
    "approvalsRequired": "Approvals required",
    "noOfPayments": "Number of Payments",
    "sendEmail": "Send email",
    "dropdownLabel": "Select Approver",
    "approver": "approver",
    "dropdownSubLabel": "You can select one or multiple approvers",
    "getErrorMessage": "Could not retrieve approvers",
    "sendErrorMessage": "Could not send email reminders"
  },
  "createPaymentDropdown": {
    "payout": "Pay out",
    "payoutDescription": "Paying a new or saved Beneficiary",
    "transfer": "Balance transfer",
    "transferDescription": "Moving money between your accounts",
    "bulkUpload": "Bulk upload",
    "bulkUploadDescription": "Mass Payment Creation"
  },
  "reviewPayments": {
    "totalAmount": "Total send amount",
    "totalReceives": "Total receives amount",
    "submitPayments": "Submit payments",
    "submitPayments_zero": "Submit payments",
    "submitPayments_one": "Submit payment ({{count}})",
    "submitPayments_other": "Submit payments ({{count}})",
    "errors": {
      "fetchPaymentsError": "An error occurred while fetching payment details. If the problem persists, please contact Client Services.",
      "fetchQuotesError": "An error occurred while fetching quotes. If the problem persists, please contact Client Services.",
      "bookTradesError": "An error occurred while booking your trade. If the problem persists, please contact Client Services."
    }
  },
  "reviewPaymentDetails": {
    "batchId": "Batch ID",
    "inputter": "Inputter",
    "inputter_one": "Inputter",
    "inputter_other": "Inputters",
    "entities": "Entities",
    "entities_one": "Entity",
    "entities_other": "Entities",
    "entityWithCount": "{{count}} Entities",
    "entityWithCount_one": "{{count}} Entity",
    "entitiesWithCount_other": "{{count}} Entities",
    "totalPayments": "Total number of payments",
    "totalAmounts": "Total send amounts",
    "currencies": "Currencies",
    "currencies_one": "Currency",
    "currencies_other": "Currencies",
    "currenciesWithCount_one": "{{count}} Currency",
    "currenciesWithCount_other": "{{count}} Currencies",
    "indicative": "Indicative",
    "transactions": "Transactions",
    "transactionsSubTitle": "Please review your transactions below and ensure the details are correct.",
    "transactionsPendingFx": "Transactions Pending FX",
    "payments": "Payment",
    "payments_one": "Payment",
    "payments_other": "Payments",
    "paymentsWithCount": "{{count}} Payments",
    "paymentsWithCount_one": "{{count}} Payment",
    "paymentsWithCount_other": "{{count}} Payments",
    "cutOffAlert": {
      "learnMore": "Learn about payment processing",
      "upcomingTitle": "Payment cut-off times may affect processing",
      "upcomingContent": "Payments are subject to cut-off times that determine when processing can begin. Submit and approve payments before the applicable cut-off time to help ensure processing starts today.",
      "pastTitle": "One or more payments have passed their cut-off time",
      "pastContent": "Processing for these payments will start in the next available processing window."
    },
    "errors": {
      "noDraftPaymentsTitle": "Nothing to submit",
      "noDraftPaymentsBody": "No draft payments were found for your selection."
    }
  },
  "reviewPaymentTable": {
    "beneficiary": "Beneficiary",
    "sendAmount": "Send Amount",
    "indiciativeRate": "Indicative Rate",
    "beneficiaryReceives": "Beneficiary receives",
    "valueDate": "Value Date",
    "approval": "Approval",
    "instantApproval": "Instant",
    "approvalRequired": "Required",
    "noResults": "There are no results",
    "reference": "Reference",
    "transactions": "Transactions",
    "transactionsSubTitle": "Please review your transactions below and ensure the details are correct."
  },
  "beneficiariesCheck": {
    "title": "Beneficiaries Check",
    "subtitle": "The payment(s) you are approving include new beneficiaries. Please review them carefully before approval, ensuring the details are correct and the payment request is genuine.",
    "breadcrumb": "Payments",
    "notValidBatch": "An error has occurred while trying to check beneficiary details. If this persists, please contact client services.",
    "noPermissions": "You do not have the required permissions to review beneficiary details.",
    "noBeneficiariesToCheck": "There are no new beneficiaries that require checking."
  },
  "bulkActions": {
    "count": "({{count}})",
    "additionalBulkActions": "Additional Bulk Actions",
    "approve": "Approve payments ({{count}})",
    "approve_one": "Approve payment ({{count}})",
    "approve_other": "Approve payments ({{count}})",
    "reject": "Reject payments ({{count}})",
    "reject_one": "Reject payment ({{count}})",
    "reject_other": "Reject payments ({{count}})",
    "delete": "Delete payments ({{count}})",
    "delete_one": "Delete payment ({{count}})",
    "delete_other": "Delete payments ({{count}})",
    "resume": "Resume payments ({{count}})",
    "resume_one": "Resume payment ({{count}})",
    "resume_other": "Resume payments ({{count}})",
    "bookFx": "Book FX ({{count}})",
    "maximumSelectionReached": "You've reached the maximum number of {{count}} selections. Please deselect any payment before selecting another.",
    "numberOfSelectedPayments": "{{count}} payments selected",
    "numberOfSelectedPayments_one": "{{count}} payment selected",
    "numberOfSelectedPayments_other": "{{count}} payments selected",
    "noPermissionTooltip": "You don't have {{action}} permissions for {{count}} payments.",
    "noPermissionTooltip_one": "You don't have {{action}} permissions for {{count}} payment.",
    "noPermissionTooltip_other": "You don't have {{action}} permissions for {{count}} payments.",
    "notCreatorTooltip": "You are not the creator of {{count}} payment(s). Only the user who created a draft payment can resume it.",
    "resumeTooltip": {
      "header": "Some selected draft payments can't be resumed.",
      "reasons": {
        "noInputterPermission": "You don't have payment inputter permissions for {{count}} payments.",
        "noInputterPermission_one": "You don't have payment inputter permissions for {{count}} payment.",
        "noInputterPermission_other": "You don't have payment inputter permissions for {{count}} payments.",
        "notCreator": "You're not the creator of {{count}} payments.",
        "notCreator_one": "You're not the creator of {{count}} payment.",
        "notCreator_other": "You're not the creator of {{count}} payments."
      }
    },
    "actions": {
      "approvePermission": "approval",
      "rejectPermission": "rejection",
      "deletePermission": "delete",
      "bookFxPermission": "FX booking",
      "resumePermission": "inputter"
    },
    "maximumSelectionReachedTitle": "Selection limit reached"
  },
  "paymentProcessingFaqModal": {
    "paymentProcessingStepsLabel": "Payment processing steps",
    "title": "How payment processing works",
    "subtitle": "Understand what your payment needs before it can begin processing.",
    "closeButton": "Close",
    "gotItButton": "Got it",
    "whatIsACutOffTime": {
      "title": "What is a cut-off time?",
      "content": "A cut-off time is the latest time a payment can become eligible for the current processing window. If the cut-off is missed, but all required steps, such as approvals and FX booking, have been completed, your payment will be processed on the next working day."
    },
    "whatMakesAPaymentEligibleForProcessing": {
      "title": "What makes a payment eligible for processing?",
      "content": "A payment becomes eligible for processing once all required steps have been completed. Completing these steps before the cut-off keeps your payment eligible for the current processing window."
    },
    "paymentProcessingSteps": {
      "submitPayment": {
        "title": "Submit Payment",
        "content": "Your payment is created and submitted to Alpha."
      },
      "completeApprovals": {
        "title": "Complete Approvals",
        "content": "All required approvers must authorise the payment before it can continue."
      },
      "bookFx": {
        "title": "Book FX (if required)",
        "content": "If the payment requires currency conversion, an FX rate must be booked before processing can begin."
      },
      "processingBegins": {
        "title": "Processing begins",
        "content": "Your payment has entered a processing window and is being processed."
      }
    }
  },
  "fxRateBookingFailureModal": {
    "title": "Some Trades Could Not Be Completed",
    "subtitle": "Failed trades have not been booked. You can continue without them or try again to rebook. If the issue persists, please contact Client Services.",
    "table": {
      "currencyPair": "Currency pair",
      "entity": "Entity",
      "status": "Status",
      "reason": "Reason"
    },
    "alert": {
      "title": "Please note",
      "content": "If you choose to try again, you will only request and view the live rates for the failed trades. Successfully booked trades will not be affected."
    },
    "reasons": {
      "reasonBookingFailed": "An error occurred. Please contact Client Services for assistance.",
      "reasonBookingFailedInsufficientFunds": "Insufficient funds to make this trade.",
      "reasonBookingFailedUserDoesNotMatch": "Another user has already initiated this trade.",
      "reasonBookingFailedQuoteExpired": "The quote is no longer valid. Please try again. If the problem persists, please contact Client Services."
    }
  },
  "insufficientFundsModal": {
    "title": "Some Trades May Exceed Available Funds",
    "description": "Based on the indicative rates, one or more of your trades may exceed the available balance in their funding accounts.",
    "submitButton": "Request live rates anyway",
    "alert": {
      "title": "Please note",
      "content": "<p>You are responsible for ensuring trades are fully funded by the settlement date. <strong>You will be liable</strong> for any losses resulting from a failure to settle on the value date. We strongly recommend taking all necessary steps to avoid delays and ensure a timely settlement.</p><p>If you choose to request the live rates anyway and book the trades you are accepting you may not have the funds to book the trades.</p>"
    },
    "table": {
      "fundingDetails": "Funding entity & account",
      "trades": "Trades",
      "currentBalance": "Current balance",
      "estimatedRequired": "Estimated required"
    }
  },
  "verificationOfPayee": {
    "errors": {
      "pleaseTryAgain": "Please try again. If the issue continues, please Client Services.",
      "pleaseTryCreatingNewBeneficiary": "Please create a new beneficiary with the correct IBAN and try again.",
      "vopValidationIbanChecksumError": "One or more beneficiaries has an invalid IBAN",
      "vopCheckError": "Unable to check beneficiary details",
      "vopActionValidationError": "Unable to complete action - some details are invalid",
      "vopValidationError": "Unable to {{check}} beneficiary details - some details are invalid",
      "vopFileUploadBatchError": {
        "title": "Unable to resume batch.",
        "body": "Please reupload the batch to continue. If the problem persists, contact Client Services."
      }
    }
  },
  "batchedPayments": {
    "multiEntityVisibilityAlert": "<0>Multi-entity batches reflect only the payments you have access to view. The Number of Payments, Pending action, Approved, and Rejected counts reflect only the payments you can see.</0> <1>Learn more</1>",
    "whyCantISeeAllPaymentsModal": {
      "title": "Why can’t I see all payments?",
      "body": "It could be because the batch contains payments funded by entities you don’t have access to. For security reasons, the counts only include payments from entities you have access to.\n\nIf the number of payments is shown as “X / Y”, you’re only seeing part of the batch. Y is the total number of payments, and X is the number you can access.\n\nIf a batch appears to be stuck in Pending, it may be due to payments requiring action from other users on entities you can’t access.\n\nIf you have any questions or need help understanding the status of a batch, please contact Client Services."
    }
  },
  "batchDetails": {
    "multiEntityVisibilityAlertTitle": "Some payments in this batch are hidden.",
    "multiEntityVisibilityAlert": "<0>This batch includes payments funded by entities you don’t have access to. The Payments and Overview tabs reflect only the payments you’re permitted to view.</0> <1>Why can’t I see all payments?</1>",
    "whyCantISeeAllPaymentsModal": {
      "title": "Why can’t I see all payments?",
      "body": "This batch contains payments funded by entities you don’t have access to. For security reasons, the Payments and Overview tabs only include payments from entities you have permission on.\n\nIf a batch appears to be stuck in Pending, it may be due to payments requiring action from other users on entities you can’t view.\n\nIf you have any questions or need help understanding the status of this batch, please contact Client Services."
    }
  },
  "multiEntitySignposting": {
    "alertTitle": "Making payments from more than one entity?",
    "alertContent": "Create a single payment batch with payments from different entities and accounts, and submit everything in one go."
  },
  "beneficiaryDeductTooltip": {
    "content": "Includes {{feeFormatted}} Beneficiary Deduct fee. Beneficiary receives {{netFormatted}}"
  }
}
